import { Injectable, signal } from '@angular/core';
import { ResetPasswordForm } from '../models/reset-password-form.model';

@Injectable({
  providedIn: 'root'
})
export class UiFeedbackService {
  #showPrincipalLayout = signal(false);
  #showToolbar = signal(false);
  #showResetPasswordModal = signal<ResetPasswordForm>({
    visible: false,
    showCancelButton: false,
    cancelButtonText: 'Cerrar'
  })

  get showPrincipalLayout() {
    return this.#showPrincipalLayout.asReadonly();
  }

  get showToolbal() {
    return this.#showToolbar.asReadonly();
  }

  get showResetPasswordModal() {
    return this.#showResetPasswordModal.asReadonly();
  }


  setShowPrincipalLayout(value: boolean) {
    this.#showPrincipalLayout.set(value);
  }

  setShowToolbar(value: boolean) {
    this.#showToolbar.set(value);
  }

  configurateResetPasswordModal({ visible, showCancelButton, cancelButtonText, initialOldPassword }: ResetPasswordForm) {
    if (visible !== undefined) {
      this.#showResetPasswordModal.update(values => ({ ...values, visible }));
    }

    if (!!cancelButtonText) {
      this.#showResetPasswordModal.update(values => ({ ...values, cancelButtonText }));
    }

    if (!!showCancelButton) {
      this.#showResetPasswordModal.update(values => ({ ...values, showCancelButton }));
    }

    if (initialOldPassword !== undefined) {
      this.#showResetPasswordModal.update(values => ({ ...values, initialOldPassword }));
    }
  }
}
